import $ from 'jquery';
import 'jquery-mousewheel';
require('malihu-custom-scrollbar-plugin')($);
import _ from 'underscore';
import Transcriptor from 'modules/transcriptor/transcriptor';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-city',
			dom: {
				input: '.js-city-input',
				dropdown: '.js-city-dropdown',
				search: '.js-city-search',
				item: '.js-city-item',
				template: {
					search: '.js-city-search-template'
				},
				form: {
					search: {
						el: '.js-city-form-search',
						query: '.js-city-form-search-query'
					}
				}
			},
			classes: {
				state: {
					open: 'b-order-city_state_open',
					search: 'b-order-city_state_search',
					empty: 'b-order-city_state_empty'
				},
				item: {
					state: {
						active: 'b-order-city__item_state_active',
						hidden: 'b-order-city__item_state_hidden'
					}
				}
			},
			size: {
				height: 34,
				count: 7
			},
			callback: {
				set: false,
				clear: false
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.searchQuery = '';
		this.preventSearch = false;
		this.searchInputDebounced = false;
		this.searchInputDebounce = false;
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$document = $(document);
		this.$window = $(window);
		this.transcriptor = new Transcriptor();
		this.data = [];
		return this;
	}

	getDom() {
		this.$input = this.$el.find(this.options.dom.input);
		this.$dropdown = this.$el.find(this.options.dom.dropdown);
		this.$list = this.$el.find(this.options.dom.list);
		this.$listItems = this.$list.find(this.options.dom.item);
		this.$search = this.$el.find(this.options.dom.search);
		this.$searchItems = this.$search.find(this.options.dom.item);
		this.$templateSearch = this.$el.find(this.options.dom.template.search);
		this.templateSearch = _.template(this.$templateSearch.html().trim());
		this.$fromSearch = this.$el.find(this.options.dom.form.search.el);
		this.$fromSearchQuery = this.$el.find(this.options.dom.form.search.query);
		return this;
	}

	addData(data) {
		const self = this;
		$.each(data, function (key, value) {
			self.data[value.id] = value;
		});
		return self;
	}

	setSearchOptions(options) {
		this.addData(options);
		this.$search.html(this.templateSearch({data: options}));
		this.$searchItems = this.$search.find(this.options.dom.item);
		this.$items = this.$searchItems;
		this.$el.toggleClass(this.options.classes.state.empty, this.$items.length === 0);
		this.$el.addClass(this.options.classes.state.search);

		this.$items.first().addClass(this.options.classes.item.state.active);
		return this;
	}

	search(query) {
		const self = this;
		const thisQuery = self.transcriptor.toCyrillic(query);
		self.searchQuery = thisQuery;
		self.$fromSearchQuery.val(thisQuery);
		$.ajax({
			url: self.$fromSearch.attr('action'),
			type: self.$fromSearch.attr('method'),
			data: self.$fromSearch.find(':input').serialize(),
			dataType: 'json',
			success: function (json) {
				if (thisQuery === self.searchQuery) {
					self.find(json);
				}
			}
		});
	}

	find(data) {
		this.setSearchOptions(data);
	}

	set(id, val = false) {
		const self = this;
		if (val != false) {
			self.$input.val(val);
		} else if (typeof self.options.callback.set == 'function') {
			self.options.callback.set(self.data[id]);
		}
		return this;
	}

	filter(query) {
		const self = this;
		const thisQuery = query;

		clearTimeout(self.searchInputDebounce);

		if (query.length >= 2) {
			self.searchInputDebounce = setTimeout(() => {
				self.searchInputDebounced = false;
				self.search(thisQuery);
			}, self.searchInputDebounced ? 0 : 300);
			self.searchInputDebounced = true;
			self.$el
				.addClass(self.options.classes.state.open);
		} else {
			self.searchQuery = '';
			self.$items = self.$listItems;
			self.$el
				.removeClass(self.options.classes.state.search)
				.removeClass(self.options.classes.state.empty);
		}
		return self;
	}

	clear() {
		this.filter('');
		this.$input.val('');
		if (typeof this.options.callback.clear == 'function') {
			this.options.callback.clear();
		}
		return this;
	}

	open() {
		const self = this;
		setTimeout(function () {
			self.$el.addClass(self.options.classes.state.open);
		}, 150);
		self.$el
			.removeClass(self.options.classes.state.search)
			.removeClass(self.options.classes.state.empty);
		self.$el.find(self.options.dom.item).removeClass(self.options.classes.item.state.active);
		self.$dropdown.data('position', 0);
		self.$dropdown.mNCustomScrollbar('scrollTo', 0);
		self.$el.trigger('yota.city.open');
		return this;
	}

	close() {
		this.$el
			.removeClass(this.options.classes.state.search)
			.removeClass(this.options.classes.state.empty)
			.removeClass(this.options.classes.state.open);

		this.$el.trigger('yota.city.close');
		this.filter('');
		this.$input.val('');
		return this;
	}

	onFocusIn() {
		const filter = this.$input.val().trim();
		this
			.open()
			.filter(filter);
		if (filter.length >= 2) {
			this.$el.addClass(this.options.classes.state.search);
		}
	}

	onDocumentClick(event) {
		const $target = $(event.target);
		if (this.$el.hasClass(this.options.classes.state.open)) {
			if (!$target.is(this.$el) && !$target.closest(this.$el).length) {
				this
					.clear()
					.close();
			}
		}
	}

	onHover(event) {
		const $target = $(event.currentTarget);
		this.$items.not($target).removeClass(this.options.classes.item.state.active);
		$target.addClass(this.options.classes.item.state.active);
	}

	selectActive() {
		const $active = this.getActive();
		if ($active !== false) {
			$active.trigger('click');
			this.$input.blur();
		}
		return this;
	}

	getActive() {
		const $visible = this.$items.filter(this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')');
		const $active = $visible.filter('.' + this.options.classes.item.state.active).eq(0);
		this.$items.not($active).removeClass(this.options.classes.item.state.active);
		if (!$active.length) {
			$visible.first().addClass(this.options.classes.item.state.active);
			return false;
		}
		return $active;
	}

	scrollToItem($active) {
		const itemHeight = $active.outerHeight(true);
		const itemTop = $active.position().top;
		const scrollTop = this.$dropdown.data('position');
		const scrollHeight = this.$dropdown.outerHeight(true);
		let scrollTo = false;
		if (itemTop < scrollTop) {
			scrollTo = itemTop;
		}
		if (itemTop + itemHeight - scrollHeight > scrollTop) {
			scrollTo = itemTop + itemHeight - scrollHeight;
		}
		if (scrollTo !== false) {
			this.$dropdown.mNCustomScrollbar('scrollTo', scrollTo);
		}
		return this;
	}

	moveActive(direction) {
		const $active = this.getActive();
		if ($active !== false) {
			let $set = $active[direction ? 'nextAll' : 'prevAll'](this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')').eq(0);
			if (!$set.length) {
				$set = this.$items.filter(':not(.' + this.options.classes.item.state.hidden + ')')[direction ? 'first' : 'last']();
			}
			this.$items.not($set).removeClass(this.options.classes.item.state.active);
			$set.addClass(this.options.classes.item.state.active);
			this.scrollToItem($set);
		}
		return this;
	}


	onInput(event) {
		const code = event.which;
		const codeUp = code === 38;
		const codeDown = code === 40;
		const codeEnter = code === 13;

		if (codeUp || codeDown || codeEnter) {
			event.preventDefault();
			if (codeEnter) {
				this.selectActive();
			} else {
				this.moveActive(codeDown);
			}
		} else if (!this.preventSearch) {
			const filter = this.$input.val().trim();
			this.filter(filter);
		}
	}

	onClick(event) {
		const $target = $(event.currentTarget);
		this.preventSearch = true;
		this.set($target.data('value'));
		this.$input.val($target.text());
		this.close();
		this.preventSearch = false;
	}

	focus() {
		this.$el.find(this.options.dom.input).focus();
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();

			self.$dropdown.mNCustomScrollbar({
				autoDraggerLength: false,
				mouseWheel: {
					enable: true,
					preventDefault: true
				},
				contentTouchScroll: self.options.size.height * 2,
				mouseWheelPixels: self.options.size.height * 2,
				scrollButtons: false,
				scrollInertia: self.options.size.height * self.options.size.count,
				theme: '',
				callbacks: {
					onCreate: function () {
						self.$dropdown.data('position', 0);
					},
					onUpdate: function () {
						if (this.mncs) {
							self.$dropdown.data('position', this.mncs.top < 0 ? -this.mncs.top : 0);
						}
					},
					whileScrolling: function () {
						if (this.mncs) {
							self.$dropdown.data('position', this.mncs.top < 0 ? -this.mncs.top : 0);
						}
					}
				}
			});

			self.$document.on('click.city', self.onDocumentClick.bind(self));

			self.$el
				.on('focusin.city', self.options.dom.input, self.onFocusIn.bind(self))
				.on('input.city paste.city keydown.city', self.options.dom.input, self.onInput.bind(self))
				.on('click.city', self.options.dom.item, self.onClick.bind(self))
				.on('mouseover.city', self.options.dom.item, self.onHover.bind(self));

		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/order/city/city.js